module.exports = __webpack_public_path__ + "static/media/fj.e7f32bd2.svg";